import NotificationsFooter from './NotificationFooter';

export default NotificationsFooter;
